class ClinicalTriages {
  constructor(note, priority, chiefComplaintId) {
    this.note = note;
    this.priority = priority;
    this.chiefComplaintId = chiefComplaintId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allClinicalTriages: [],
      clinicalTriage: new ClinicalTriages('', null, null),
      allClinicalTriagessForOther: [],
    };
  },
  methods: {
    getListOfClinicalTriagesForOther: function (chiefCompliantId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllClinicalTriages', Number(chiefCompliantId)).then(() => {
        if (this.$store.state.clinicalTriageModule.successFlag) {
          this.allClinicalTriagessForOther =
            this.$store.state.clinicalTriageModule.allClinicalTriages;
          if (this.formLoad) {
            this.compliantClinicalTriageList = this.allClinicalTriagessForOther?.filter((item) => item?.isActive);
            this.compliantClinicalTriageList.forEach((c) => {
              c.isSelected = false;
              c.isDisable = false;
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clinicalTriageModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfClinicalTriagesForOther(chiefCompliantId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clinicalTriageModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfClinicalTriagesForOther(chiefCompliantId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllClinicalTriages: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllClinicalTriages', Number(this.$route.params.id)).then(() => {
        if (this.$store.state.clinicalTriageModule.successFlag) {
          let temp = this.$store.state.clinicalTriageModule.allClinicalTriages;
          this.allClinicalTriages = [];
          for (let i = 0; i < temp.length; i++) {
            this.allClinicalTriages.push({
              note: temp[i].note ? temp[i].note : '-',
              priority: temp[i].priority ? temp[i].priority : '-',
              counter: i + 1,
              id: temp[i].id,
            });
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clinicalTriageModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllClinicalTriages();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clinicalTriageModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllClinicalTriages();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addClinicalTriagesFunction: function () {
      if (!this.clinicalTriage.note) {
        this.snackText = 'عنوان توصیه/راهنما نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.clinicalTriage.note.replace(/\s/g, '').length) {
        this.snackText = 'عنوان توصیه/راهنما نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.clinicalTriage.priority) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.clinicalTriage.priority = Number(this.clinicalTriage.priority);
      this.clinicalTriage.chiefComplaintId = this.chiefComplaintId;
      this.$store.dispatch('addClinicalTriage', this.clinicalTriage).then(() => {
        if (this.$store.state.clinicalTriageModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' توصیه/راهنما با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.clinicalTriage = new ClinicalTriages('', null, null);
          this.getAllClinicalTriages();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clinicalTriageModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addClinicalTriagesFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clinicalTriageModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addClinicalTriagesFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getClinicalTriagesFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getClinicalTriage', id).then(() => {
        if (this.$store.state.clinicalTriageModule.successFlag) {
          let temp = this.$store.state.clinicalTriageModule.clinicalTriage;
          this.clinicalTriage.id = temp.id;
          this.clinicalTriage.note = temp.note;
          this.clinicalTriage.priority = temp.priority;
          this.clinicalTriage.chiefComplaintId = this.chiefComplaintId;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clinicalTriageModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getClinicalTriagesFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clinicalTriageModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getClinicalTriagesFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editClinicalTriagesFunction: function () {
      if (!this.clinicalTriage.note) {
        this.snackText = 'عنوان توصیه/راهنما نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.clinicalTriage.note.replace(/\s/g, '').length) {
        this.snackText = 'عنوان توصیه/راهنما نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.clinicalTriage.priority) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.clinicalTriage.chiefComplaintId = this.chiefComplaintId;
      if (!this.load.val) {
        this.load.val = true;
      }
      this.clinicalTriage.priority = Number(this.clinicalTriage.priority);
      this.$store.dispatch('editClinicalTriage', this.clinicalTriage).then(() => {
        if (this.$store.state.clinicalTriageModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllClinicalTriages();
          this.snackText = ' توصیه/راهنما با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.clinicalTriage = new ClinicalTriages('', null, null);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clinicalTriageModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editClinicalTriagesFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clinicalTriageModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editClinicalTriagesFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteClinicalTriagesFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteClinicalTriage', this.clinicalTriagesId).then(() => {
        if (this.$store.state.clinicalTriageModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllClinicalTriages();
          this.snackText = ' توصیه/راهنما با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clinicalTriageModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteClinicalTriagesFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clinicalTriageModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteClinicalTriagesFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.clinicalTriageModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
